import { render } from "./GavContractsResults.vue?vue&type=template&id=4c75bf11&ts=true"
import script from "./GavContractsResults.vue?vue&type=script&lang=ts"
export * from "./GavContractsResults.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__